import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  headers: any = {
		'Content-Type': 'application/json'
	};
  
  constructor(
    private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
  ) { }

  getScormCourseList(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `resource/manage`;
		return this.http.get(api, options);
	}
  
  getScormLms(headers: any = {}, resourceID: number){
    const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `scorm/log?resourceID=${resourceID}`;
		return this.http.get(api, options);
  }

  getSettingsFromParams(urlParams) {
    const settings = {
      autocommit: true,
      autocommitSeconds: 30,
      dataCommitFormat: 'json',
      commitRequestDataType: 'application/json;charset=UTF-8',
      autoProgress: false,
      logLevel: 1,
      mastery_override: false,
      xhrHeaders:    {
        "AllowedHeaders": ["*"],
        "AllowedMethods": ["GET"],
        "Access-Control-Allow-Origin": ["*"]
    }
    };

    if (urlParams.get('autocommit') !== null) {
      settings.autocommit = (urlParams.get('autocommit') === 'true');
    }
    if (urlParams.get('autocommitSeconds') !== null) {
      let seconds = parseInt(urlParams.get('autocommitSeconds'));
      if (isNaN(seconds)) {
        seconds = 60; // default
      }
      settings.autocommitSeconds = seconds;
    }
    if (urlParams.get('dataCommitFormat') !== null) {
      const format = urlParams.get('dataCommitFormat');
      if (format !== null) {
        if (format === 'json' || format === 'params' || format === 'flattened') {
          settings.dataCommitFormat = format;
        }
      }
    }
    if (urlParams.get('logLevel') !== null) {
      let level = parseInt(urlParams.get('logLevel'));
      if (isNaN(level) || level < 1 || level > 5) {
        level = 4; // default
      }
      settings.logLevel = level;
    }

    return settings;
  }

}
